import React from "react"
import { MobilePhoneIconSolid } from "../../common/Icons"
// import GooglePlusLogo from "../../sign/common/SocialMediaLogin/GooglePlusLogo"
// import FacebookLogo from "../../sign/common/SocialMediaLogin/FacebookLogo"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
// import GoogleLogin from "react-google-login"

function EmailLoginButton({ onClickHandler }) {
  return (
    <button type="button" className="EmailLoginButton" onClick={onClickHandler}>
      <MobilePhoneIconSolid />
      <span>Log in with mobile</span>
    </button>
  )
}

function CustomerLoginButtons({
  guestLoginHandler,
  emailLoginHandler,
  // googleLoginHandler,
  // facebookLoginHandler,
  showAccountRegister
}) {
  // function GoogleLoginButton({ onClick }) {
  //   return (
  //     <button className="GoogleLoginButton" onClick={onClick}>
  //       <GooglePlusLogo />
  //       <span>Log in with Google</span>
  //     </button>
  //   )
  // }

  // function FacebookLoginButton({ onClick }) {
  //   return (
  //     <button className="FacebookLoginButton" onClick={onClick}>
  //       <FacebookLogo />
  //       <span>Log in with Facebook</span>
  //     </button>
  //   )
  // }

  return (
    <div className="CustomerLoginButtons">
      <button type="button" className="guest" onClick={guestLoginHandler}>
        Checkout as guest
      </button>
      <EmailLoginButton onClickHandler={emailLoginHandler} />
      {/* <FacebookLogin
        appId="491913011631586"
        fields="name,email, first_name, last_name"
        callback={facebookLoginHandler}
        render={FacebookLoginButton}
      />
      <GoogleLogin
        clientId="362716177951-jiqbt7o0fs8s2lomi1elfc7dhv0r9ri2.apps.googleusercontent.com"
        render={GoogleLoginButton}
        onSuccess={googleLoginHandler}
        onFailure={googleLoginHandler}
        cookiePolicy={"single_host_origin"}
        fetchBasicProfile={true}
      /> */}
      <p>
        Don't have an account?{" "}
        <span className="link" onClick={showAccountRegister}>
          Sign up
        </span>
      </p>
    </div>
  )
}

export default CustomerLoginButtons
